import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["barcodeInput", "cameraModal", "cameraRegion", "fileInput", "result", "status"]

  connect() {
    this.scanner = null
    this.scanning = false
    this.Html5Qrcode = null
  }

  async loadLibrary() {
    if (!this.Html5Qrcode) {
      const mod = await import("html5-qrcode")
      this.Html5Qrcode = mod.Html5Qrcode
    }
    return this.Html5Qrcode
  }

  disconnect() {
    this.stopScanner()
  }

  async openCamera() {
    this.clearMessages()
    this.cameraModalTarget.classList.remove("hidden")

    try {
      const Html5Qrcode = await this.loadLibrary()
      this.scanner = new Html5Qrcode(this.cameraRegionTarget.id)
      this.scanning = true

      await this.scanner.start(
        { facingMode: "environment" },
        { fps: 10, qrbox: { width: 250, height: 150 } },
        (decodedText) => this.onScanSuccess(decodedText),
        () => {} // ignore per-frame failures
      )
    } catch (err) {
      this.scanning = false
      this.showStatus(err.message || "Unable to access camera. Please check permissions.", true)
      this.cameraModalTarget.classList.add("hidden")
    }
  }

  async closeCamera() {
    await this.stopScanner()
    this.cameraModalTarget.classList.add("hidden")
  }

  uploadImage() {
    this.fileInputTarget.click()
  }

  async handleFileSelect(event) {
    const file = event.target.files[0]
    if (!file) return

    this.clearMessages()

    try {
      const Html5Qrcode = await this.loadLibrary()
      const tempScanner = new Html5Qrcode("barcode-file-scan-temp")
      const decodedText = await tempScanner.scanFile(file, false)
      tempScanner.clear()
      this.onScanSuccess(decodedText)
    } catch {
      this.showStatus("No barcode detected in the image. Try a clearer photo.", true)
    }

    // Reset file input so the same file can be re-selected
    event.target.value = ""
  }

  onScanSuccess(decodedText) {
    this.barcodeInputTarget.value = decodedText
    this.barcodeInputTarget.dispatchEvent(new Event("change", { bubbles: true }))
    this.showResult(`Barcode detected: ${decodedText}`)
    this.closeCamera()
  }

  async stopScanner() {
    if (this.scanner && this.scanning) {
      try {
        await this.scanner.stop()
      } catch { /* already stopped */ }
      this.scanner.clear()
      this.scanning = false
    }
  }

  showResult(message) {
    this.resultTarget.textContent = message
    this.resultTarget.classList.remove("hidden")
    this.statusTarget.classList.add("hidden")
  }

  showStatus(message, isError = false) {
    this.statusTarget.textContent = message
    this.statusTarget.classList.remove("hidden")
    this.statusTarget.classList.toggle("text-red-600", isError)
    this.statusTarget.classList.toggle("dark:text-red-400", isError)
    this.resultTarget.classList.add("hidden")
  }

  clearMessages() {
    this.resultTarget.classList.add("hidden")
    this.statusTarget.classList.add("hidden")
  }
}
